import { useState } from "react"
import { router } from "@inertiajs/react"
import { StepShell } from "../components/StepShell"

export function AuditIntro() {
  const [processing, setProcessing] = useState(false)

  // PATCH (not GET) so the server advances `furthest_step` to audit_intro.
  // Without this, a user who bails mid-audit returns to the audit-intro
  // screen on next visit because the wizard has no record they saw it
  // the first time.
  const goNext = () => {
    setProcessing(true)
    router.patch(
      "/app/plan/intake",
      { step: "audit_intro", advance: "1" },
      {
        preserveScroll: true,
        onFinish: () => setProcessing(false),
      },
    )
  }

  return (
    <StepShell
      title="The Integrated Life Audit"
      subtitle="Thirty short questions across six areas of life."
      onNext={goNext}
      nextLabel="Start the audit"
      processing={processing}
    >
      <div className="space-y-4 text-zinc-700 text-sm sm:text-base leading-relaxed">
        <p>
          We'll ask you to rate yourself 1–5 on five questions in each of six
          categories: <strong>Faith</strong>, <strong>Family</strong>,{" "}
          <strong>Physical Wellness</strong>,{" "}
          <strong>Financial</strong>, <strong>Business/Work</strong>, and{" "}
          <strong>Relationships/Recreation</strong>.
        </p>
        <p>
          This isn't a test. There are no wrong answers — just your honest
          reflection right now. The results form your <em>Integrated Life Audit</em>
          snapshot, which we'll revisit together.
        </p>
        <div className="bg-zinc-50 border border-zinc-200 rounded-md px-4 py-3 text-xs text-zinc-600">
          <strong className="text-zinc-800">Scale:</strong> 1 = needs real
          attention · 3 = doing okay · 5 = thriving
        </div>
      </div>
    </StepShell>
  )
}
